<template>
  <div>
    <div class="filters">
      <!-- 基础指标 -->
      <Select v-model="target" @change="handleBaseSelectChange">
        <Option
          v-for="item in targetList"
          :key="item.value"
          :value="item.value"
          :label="item.label"
          :disabled="item.value === targetContrast && showContrast"
        />
      </Select>

      <span v-if="showContrastFeature">
        <Checkbox class="checkbox" v-model="showContrast" @change="handleCheckboxChange">指标对比</Checkbox>

        <!-- 对比指标 -->
        <Select v-if="showContrast" v-model="targetContrast" @change="handleContrastSelectChange">
          <Option
            v-for="item in targetList"
            :key="item.value"
            :value="item.value"
            :label="item.label"
            :disabled="item.value === target"
          />
        </Select>
      </span>
    </div>

    <ChartTrend :dataSource="data" :yAxisNames="yAxisNames" />
  </div>
</template>

<script>
import { Select, Option, Checkbox } from 'element-ui';

import ChartTrend from './components/Chart/Trend';

import { getTrendAnalysisTargetsList } from './config/';

export default {
  components: {
    Select,
    Option,
    Checkbox,

    ChartTrend
  },

  props: {
    // 图表数据
    dataSource: {
      type: Object,
      required: true
    },

    // 默认指标
    defaultTarget: {
      type: String
    },

    // 是否开启指标对比功能
    showContrastFeature: {
      type: Boolean,
      default: true
    }
  },

  watch: {
    dataSource(newVal) {
      this.data = newVal;
    }
  },

  data() {
    return {
      // 默认指标
      target: this.defaultTarget,
      // 对比指标
      targetContrast: 'click_total',
      // 指标列表
      targetList: getTrendAnalysisTargetsList(),
      data: this.dataSource,
      showContrast: false,
      yAxisNames: []
    };
  },

  methods: {
    handleBaseSelectChange(key) {
      this.$emit('change', { type: 'base', key });
      this.$set(this.yAxisNames, 0, this.getTargetName(key));
    },

    handleContrastSelectChange(key) {
      this.$emit('change', { type: 'contrast', key });
      this.$set(this.yAxisNames, 1, this.getTargetName(key));
    },

    handleCheckboxChange(value) {
      if (value) {
        this.$emit('change', { type: 'contrast', key: this.targetContrast });
        // 设置对比指标信息
        this.$set(this.yAxisNames, 1, this.getTargetName(this.targetContrast));
      } else {
        this.$emit('change', { type: 'contrast', key: undefined });
        this.yAxisNames.splice(1, 1);
      }
    },

    getTargetName(key) {
      const [target] = this.targetList.filter(target => target.value === key);
      return target;
    }
  },

  created() {
    this.yAxisNames[0] = this.getTargetName(this.target);
  }
};
</script>

<style lang="less" scoped>
.filters {
  margin-bottom: 20px;
}

.checkbox {
  margin: 0 10px;
}
</style>
